"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SingleSelection = require("../context/SingleSelection");

var _core = require("@material-ui/core");

var _excluded = ["value", "onChange", "children"];

/**
 * A group of options which are mutually exclusive.
 */
var RadioGroup = function RadioGroup(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SingleSelection.SingleSelectionProvider, {
    value: {
      selected: value,
      onSelect: onChange
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, props, children));
};

RadioGroup.propTypes = {
  /** The value of the component. */
  value: _propTypes["default"].any,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired,

  /**
   * Callback fired when the component is changed.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onChange: _propTypes["default"].func.isRequired
};
var _default = RadioGroup;
exports["default"] = _default;